import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { City } from "@models/city";
import { deleteRequest, fetchRequest } from "@actions/city";
import CityForm from "@components/cities/Form";
import { createRequest, updateRequest } from "@actions/city";
import cityApi from "@api/city";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: City[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CityFormPage extends React.Component<AllProps> {
  state = {
    city: null,
    city_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.city_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    cityApi
      .getItem({
        params: {
          id: this.state.city_id
        }
      })
      .then(({ data }) => {
        this.setState({
          city: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.city_id && !this.state.city) {
      return null;
    }

    return (
      <CityForm
        city={this.state.city}
        intl={this.props.intl}
        listUrl={"/cities"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ cities }: ApplicationState) => ({
  loading: cities.loading,
  errors: cities.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CityFormPage));
